import { jsx as n, jsxs as V } from "react/jsx-runtime";
import { useWatch as C, UnprocessableContentError as W } from "@systemeio/util";
import { ContactSlugEnum as s } from "@systemeio/ui";
import { useState as m } from "react";
import _ from "../../components/card-wrapper.mjs";
import z from "../../components/field.mjs";
import N from "../../components/item-thumbnail-base.mjs";
import P from "../../ui-kit/theme-button.mjs";
import { getDefaultFieldValues as d } from "../../utils/get-default-field-values.mjs";
import { handleOptin as U } from "./api/index.mjs";
import { useVisitorInfoStore as Z } from "../../store/index.mjs";
import { StoreImageEnum as $ } from "../../enums/store-image-enum.mjs";
const Y = ({
  id: i,
  title: O,
  subTitle: x,
  thumbnail: F,
  fields: u,
  buttonTitle: E,
  thankYouPage: l,
  headingLevel: I
}) => {
  const [S, c] = m(!1), [p, f] = m({}), [o, a] = m(
    d(u)
  ), { visitorInfo: j } = Z();
  C(u, (t) => a(d(t))), C(j, (t) => {
    if (!t) return;
    const e = Object.prototype.hasOwnProperty.call(o, s.Country) && !o[s.Country].value;
    t.country && e && a({
      ...o,
      [s.Country]: {
        ...o[s.Country],
        value: t.country
      }
    });
  });
  const T = async () => {
    var e;
    if (!i) return;
    const t = Object.values(o).map((r) => ({
      slug: r.slug,
      value: r.value ?? ""
    }));
    try {
      f({}), c(!0);
      const r = Intl.DateTimeFormat().resolvedOptions().timeZone;
      await U({
        itemOptIn: `/api/dashboard/digital-store/item-opt-ins/${i}`,
        values: t,
        timezone: r
      }), l.path && window.location.assign(l.path);
    } catch (r) {
      r instanceof W && ((e = r.errors.violations) == null || e.forEach((h) => {
        var y;
        const w = /values\[(\d+)]/, g = h.propertyPath.match(w);
        if (g) {
          const D = parseInt(g[1]), b = (y = t.find((v, B) => B === D)) == null ? void 0 : y.slug;
          b && f((v) => ({ ...v, [b]: h.message }));
        }
      }));
    } finally {
      c(!1);
    }
  };
  return /* @__PURE__ */ n(_, { children: /* @__PURE__ */ V(
    "form",
    {
      onSubmit: (t) => {
        t.preventDefault(), T();
      },
      className: "flex flex-col gap-3",
      children: [
        /* @__PURE__ */ n(
          N,
          {
            title: O,
            subTitle: x,
            imageType: $.optin_thumbnail,
            thumbnail: F,
            headingLevel: I
          }
        ),
        Object.values(o).map((t) => {
          const e = (r) => a({
            ...o,
            [t.slug]: { ...t, value: r }
          });
          return /* @__PURE__ */ n(
            z,
            {
              contactFields: o,
              field: t,
              value: o[t.slug].value,
              error: p[t.slug] ? [p[t.slug]] : [],
              onChange: e
            },
            t.slug
          );
        }),
        /* @__PURE__ */ n(P, { isFetching: S, type: "submit", children: E })
      ]
    }
  ) });
};
export {
  Y as default
};
